// extracted by mini-css-extract-plugin
export default {"header_container":"style_header_container__u4G7W","left_area":"style_left_area__4xmyc","heading":"style_heading__c24RL","sub_heading":"style_sub_heading__62M55"};